import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { IntegerField } from '@components/Fields/IntegerField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { EnumDespesaStatus, IComboDespesaStatus } from '@model/Despesa';
import { IComboEmpresa } from '@model/Empresa';
import { IDespesaFilter } from '@services/DespesaService';
import React from 'react';

export type DespesaFilterProps = {
    filter: IFilter<IDespesaFilter>
    isLoading: boolean
    despesaStatusCombo: IComboDespesaStatus
    empresaCombo: IComboEmpresa
}

export function DespesaFilter ({ filter, isLoading, despesaStatusCombo, empresaCombo }: DespesaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <IntegerField
                        field={filter.fields.despesaId}
                        label="ID"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        autoFocus
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumDespesaStatus.None}>Todas</MenuItem>
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={3}>
                    <StringField
                        field={filter.fields.descricao}
                        label="Descrição"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competenciaReferencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.status}
                        label="Status"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem value={EnumDespesaStatus.None}>Todos</MenuItem>
                        {
                            despesaStatusCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}